import axios from 'axios';
import {backendHost} from '../../config';

export const getDashboardReplenishment = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/dashboard/replenishment`, {params});
};